import _isEmpty from 'lodash/isEmpty'

// BNA title short version threshold
export const bnaSectionTitleLimits = {
  DESKTOP: 36,
  TABLET: 36,
  MOBILE: 21,
}

// Function to filter list of words from url for SEO purpose
export const filterURLWordSEO = (articleTitle) => {
  //TODO:: check on this later
  // try {
  //   if (true) {
  //     // Will remove special character from the string to filter out words
  //     const specialCharactersToReplace = /[?.,!{}()"-]/g; // Add characters here to remove it from the article
  //     const seoWordsLowerCase = seoURlFilter.filterWords.map((item) => item.toLowerCase());
  //     return articleTitle
  //       .replace(specialCharactersToReplace, '')
  //       .toLowerCase()
  //       .split(' ')
  //       .filter((item) => !seoWordsLowerCase.includes(item))
  //       .join(' ');
  //   }
  //   return articleTitle;
  // } catch (e) {
  //   return articleTitle;
  // }
  return articleTitle
}

export const getFaqUrlFromTitle = (title) => {
  return encodeURIComponent(
    title &&
      filterURLWordSEO(title)
        .replace(/ /g, '-')
        .replace(/\?/g, '')
        .replace(/[/\\]/g, '-')
        .toLowerCase(),
  )
}

export const getTitleForArticleUrl = (title, articleId) => {
  return decodeURIComponent(
    `${getFaqUrlFromTitle(filterURLWordSEO(title))}-${articleId.toLowerCase()}`,
  )
}

export const isRenderingOnServer = () => {
  return typeof window === 'undefined'
}

// Filter top contact reason response data
export const filterSearchResponse = (responseData) => {
  if (!Array.isArray(responseData)) {
    return []
  }
  return responseData.slice(0, 5).map((article, index) => ({
    id: `suggestion_${index + 1}`,
    value: article.articleTitle || article.document_title,
    docid: article.articleId || article.document_id,
  }))
}

export const getSanitizedValue = (value) => {
  const returnValue = value ? value.trim() : ''
  try {
    return encodeURIComponent(returnValue)
  } catch (error) {
    return returnValue
  }
}
